export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/fixture.worker.3022c1a6.worker.js");
}
